export default __webpack_public_path__ + "static/media/WaterTower.d2faae14.jpg";